<template>
  <div id="add-contact-l2">
    <section class="toggle-header">
      <div class="text-wrapper">
        <div class="input-wrapper position-relative first">
          <span class="ver-center">Name of Event</span>
          <div class="pl-120">
            <input
              @input="setName($event.target.value)"
              :value="name.firstName"
              type="text"
              placeholder="Name of event"
              class="title mb-0 font-16"
            />
          </div>
        </div>
      </div>
      <div class="btn-wrapper full-width float-left">
        <a
          href="#"
          class="btn-toggle-sumbit buttonstyle"
          @click.prevent="showPopupLocal"
          >Add Event</a
        >
        <a
          href="#"
          class="btn-toggle-sumbit buttonstyle"
          @click.prevent="hideDropDown"
          >Cancel</a
        >
      </div>
      <!-- Pop up -->
      <div class="popup" v-show="showPopup">
        <transition name="pop">
          <popup-vue
            v-if="showPopup"
            :hide="hideThePopup"
            :additional-function="hideDropDown"
          />
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import PopupVue from "../../../Event/AddEvent/Popup";
import { addNewHomeMixin } from "../../../../mixins/addNewHomeMixin";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  mixins: [addNewHomeMixin],
  props: {
    hideDropDown: Function
  },
  data() {
    return {
      showPopup: false
    };
  },
  computed: {
    ...mapGetters("addNew", {
      name: "getName"
    }),
    ...mapGetters("event", {
      validated: "getValidated"
    })
  },
  methods: {
    ...mapMutations("addNew", {
      setName: "setFirstName"
    }),
    ...mapMutations("event", {
      setValidated: "setValidated"
    }),
    ...mapActions("event", {
      validate: "validate"
    }),
    showThePopup() {
      this.showPopup = true;
    },
    hideThePopup() {
      this.showPopup = false;
    },
    showPopupLocal() {
      this.validate();
    }
  },
  components: {
    PopupVue
  },
  watch: {
    validated(value) {
      if (value) {
        this.showThePopup();
        this.setValidated(false);
      }
    }
  },
  destroyed() {
    this.clearState();
  },
  created() {
    this.clearState();
  }
};
</script>

<style scoped>
.input-wrapper input {
  border: none !important;
}

.popup {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

/* stage 2. Entered */
.pop-enter-active {
  animation: pop-in 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.pop-leave-active {
  animation: pop-out 0.2s ease-in-out forwards;
}

@keyframes pop-in {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop-out {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
</style>
